<mat-drawer-container autosize class="drawer-container">
  <mat-drawer-content>
    <div class="container" fxLayout="row" fxLayoutAlign="center none">
      <div fxFlex="95%" class="wrapper">
        <mat-card>
          <mat-card-content>
            <div
              class="search-panel"
              fxLayout="row"
              fxLayoutGap="10px"
              fxLayoutAlign="space-between Normal"
            >
              <app-search-box
                class="search-box"
                [value]="searchValue"
                (filterValueChange)="onFilterValueChange($event)"
              ></app-search-box>
              <button
                mat-raised-button
                color="primary"
                class="action-btn btn-add"
                (click)="add()"
              >
                {{ "Add" | translate }}
              </button>
            </div>
            <div class="table-wrapper">
              <table
                mat-table
                [dataSource]="dataSource"
                matSort
                class="table"
                matSortDisableClear
              >
                <ng-container matColumnDef="details.name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header="name">
                    {{ "Hospital Name" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.name }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="details.address">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header="address.line1"
                  >
                    {{ "Hospital Address" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.address.line1 }},
                    {{ element.address.city.name }},
                    {{ element.address.state.name }},
                    {{ element.address.zipCode }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="createdAt">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header="createdAt"
                  >
                    {{ "AddedDate" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <p>
                      {{
                        element.createdAt
                          ? (element.createdAt | date: "dd/MM/yyyy")
                          : "-"
                      }}
                    </p>
                  </td>
                </ng-container>

                <ng-container matColumnDef="rooms">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ "Masters.clinics.Room" | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <div
                      class="room-data-container"
                      *ngIf="element?.rooms?.length > 0; else addRoom"
                      [matTooltip]="createRoomHtml(element?.rooms).all"
                    >
                      <p class="room-text-turncate">
                        {{ createRoomHtml(element?.rooms).text }}
                      </p>
                      <p
                        class="room-count"
                        *ngIf="createRoomHtml(element?.rooms).count > 0"
                      >
                        +{{ createRoomHtml(element?.rooms).count }}
                      </p>
                    </div>
                    <ng-template #addRoom>
                      <p class="link" (click)="addClinicRoom(element)">
                        {{ "Masters.clinics.AddRoom" | translate }}
                      </p>
                    </ng-template>
                  </td>
                </ng-container>

                <ng-container matColumnDef="actions" stickyEnd>
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    class="table-action-separator-right"
                  >
                    {{ "Actions" | translate }}
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    class="action-row table-action-separator-right"
                  >
                    <div class="manage-clinic-action-btn">
                      <button
                        mat-icon-button
                        matTooltip="Edit Rooms"
                        color="primary"
                        (click)="addClinicRoom(element)"
                      >
                        <mat-icon color="primary">add_home</mat-icon>
                      </button>
                      <button
                        mat-icon-button
                        matTooltip="Edit Hospital"
                        color="primary"
                        (click)="editClinic(element, element.id)"
                      >
                        <mat-icon
                          class="edit-icon-sm"
                          svgIcon="edit"
                        ></mat-icon>
                      </button>
                      <button
                        mat-icon-button
                        matTooltip="Map Service/Package"
                        color="primary"
                        (click)="openAddServiceDialog(element.id)"
                      >
                        <mat-icon
                          class="edit-icon-sm"
                          svgIcon="page-link"
                        ></mat-icon>
                      </button>
                      <button
                        mat-icon-button
                        matTooltip="Prescription Setup"
                        color="primary"
                        (click)="openLetterheadDrawer(element)"
                      >
                        <mat-icon>article</mat-icon>
                      </button>

                      <button
                        mat-icon-button
                        matTooltip="Sub Store"
                        color="primary"
                        (click)="openSubStore(element.id)"
                      >
                        <mat-icon
                          class="edit-icon-sm"
                          svgIcon="sub-store"
                        ></mat-icon>
                      </button>
                    </div>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumns"
                ></tr>
              </table>
            </div>
            <mat-paginator
              #paginator
              [pageSizeOptions]="[10, 20, 50]"
              showFirstLastButtons
            ></mat-paginator>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </mat-drawer-content>

  <mat-drawer
    mode="over"
    position="end"
    class="drawer-header-content"
    [(opened)]="isLetterheadDrawerOpen"
  >
    <div class="drawer-header">
      <h2 class="drawer-title">Prescription Setup</h2>
      <mat-icon class="close-icon" (click)="closeLetterheadDrawer()"
        >close</mat-icon
      >
    </div>

    <div class="drawer-content">
      <p class="drawer-subtitle" *ngIf="selectedClinicForLetterhead">
        Clinic: {{ selectedClinicForLetterhead.name }}
      </p>
      <div class="drawer-loading" *ngIf="isLetterheadLoading">
        <mat-spinner diameter="36"></mat-spinner>
        <span>Loading prescription assets...</span>
      </div>

      <form
        [formGroup]="letterheadForm"
        class="drawer-form"
        [class.form-disabled]="isLetterheadLoading"
      >
        <!-- <mat-form-field
          appearance="outline"
          class="full-width"
          style="font-size: 12px"
        >
          <mat-label>Services offered</mat-label>
          <input matInput formControlName="letterheadName" />
        </mat-form-field> -->

        <div class="upload-section">
          <div class="upload-title">Logo Image*</div>
          <div class="upload-hint">
            Recommended ratio: 3:1 (example: 570 x 190 px)
          </div>
          <label class="upload-box">
            <input
              type="file"
              accept="image/*"
              (change)="onLetterheadImageChange($event, 'headerImage')"
            />
            <span>{{
              letterheadForm.get("headerImage")?.value
                ? getLetterheadImageDisplayName("headerImage")
                : "Upload Logo image"
            }}</span>
          </label>
          <div
            class="validation-error"
            *ngIf="
              letterheadForm.get('headerImage')?.hasError('required') &&
              letterheadForm.get('headerImage')?.touched
            "
          >
            Logo image is required
          </div>
          <div
            class="preview-container"
            *ngIf="letterheadForm.get('headerImage')?.value"
          >
            <div class="preview-loader" *ngIf="imageLoadingState.headerImage">
              <mat-spinner diameter="28"></mat-spinner>
            </div>
            <img
              *ngIf="letterheadImagePreview.headerImage"
              [src]="letterheadImagePreview.headerImage"
              alt="Header preview"
              class="image-preview"
              [class.image-loading]="imageLoadingState.headerImage"
              (click)="openLetterheadImagePreview('headerImage')"
              (load)="onLetterheadPreviewLoad('headerImage')"
              (error)="onLetterheadPreviewError('headerImage')"
              matTooltip="Click to preview"
            />
            <mat-icon
              class="remove-icon"
              (click)="clearLetterheadImage('headerImage')"
              svgIcon="reject"
              matTooltip="Remove Logo"
            ></mat-icon>
          </div>
        </div>

        <div class="upload-section">
          <div class="upload-title">Footer Image*</div>
          <div class="upload-hint">
            Recommended ratio: 6.6:1 (example: 1122 x 170 px)
          </div>
          <label class="upload-box">
            <input
              type="file"
              accept="image/*"
              (change)="onLetterheadImageChange($event, 'footerImage')"
            />
            <span>{{
              letterheadForm.get("footerImage")?.value
                ? getLetterheadImageDisplayName("footerImage")
                : "Upload footer image"
            }}</span>
          </label>
          <div
            class="validation-error"
            *ngIf="
              letterheadForm.get('footerImage')?.hasError('required') &&
              letterheadForm.get('footerImage')?.touched
            "
          >
            Footer image is required
          </div>
          <div
            class="preview-container"
            *ngIf="letterheadForm.get('footerImage')?.value"
          >
            <div class="preview-loader" *ngIf="imageLoadingState.footerImage">
              <mat-spinner diameter="28"></mat-spinner>
            </div>
            <img
              *ngIf="letterheadImagePreview.footerImage"
              [src]="letterheadImagePreview.footerImage"
              alt="Footer preview"
              class="image-preview"
              [class.image-loading]="imageLoadingState.footerImage"
              (click)="openLetterheadImagePreview('footerImage')"
              (load)="onLetterheadPreviewLoad('footerImage')"
              (error)="onLetterheadPreviewError('footerImage')"
              matTooltip="Click to preview"
            />
            <mat-icon
              class="remove-icon"
              (click)="clearLetterheadImage('footerImage')"
              svgIcon="reject"
              matTooltip="Remove Footer"
            ></mat-icon>
          </div>
        </div>
      </form>
    </div>

    <div class="drawer-actions">
      <button
        class="cancel-button"
        mat-stroked-button
        type="button"
        (click)="closeLetterheadDrawer()"
      >
        Cancel
      </button>
      <button
        class="submit-button"
        mat-flat-button
        color="primary"
        type="button"
        [disabled]="
          isLetterheadLoading || isSavingLetterhead || letterheadForm.invalid
        "
        (click)="saveLetterhead()"
      >
        <mat-spinner
          *ngIf="isSavingLetterhead"
          diameter="18"
          class="save-spinner"
        ></mat-spinner>
        {{ isSavingLetterhead ? "Saving..." : "Save" }}
      </button>
    </div>
  </mat-drawer>
</mat-drawer-container>
